import useLocalStorage from '~/hooks/useLocalStorage';

import {
  DEFAULT_SUGGESTION_QUERY_CONFIG,
  type SuggestionQueryConfig,
  sanitiseSuggestionQueryConfig,
} from './categoriseSearchGroups';

export const SUGGESTION_QUERY_CONFIG_STORAGE_KEY = 'analytics.suggestionQueryConfig';

export function useSuggestionQueryConfig() {
  const [storedValue, setStoredValue, clearValue] = useLocalStorage(SUGGESTION_QUERY_CONFIG_STORAGE_KEY, null) as [
    SuggestionQueryConfig | null,
    (value: SuggestionQueryConfig) => void,
    () => void,
  ];

  const config = storedValue === null ? DEFAULT_SUGGESTION_QUERY_CONFIG : sanitiseSuggestionQueryConfig(storedValue);
  const isCustomised = storedValue !== null;

  const setConfig = (next: SuggestionQueryConfig) => {
    setStoredValue(sanitiseSuggestionQueryConfig(next));
  };

  return { config, setConfig, resetConfig: clearValue, isCustomised };
}
